export default "__VITE_ASSET__c468f587__"